import { render, staticRenderFns } from "./CourseTimeRange.vue?vue&type=template&id=05a540e4&scoped=true&"
import script from "./CourseTimeRange.vue?vue&type=script&lang=js&"
export * from "./CourseTimeRange.vue?vue&type=script&lang=js&"
import style0 from "./CourseTimeRange.vue?vue&type=style&index=0&id=05a540e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a540e4",
  null
  
)

export default component.exports